/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1AccesscontrolPermissionsUpsertBatch202,
  PostApiV1AccesscontrolPermissionsUpsertBatch400,
  PostApiV1AccesscontrolPermissionsUpsertBatch401,
  PostApiV1AccesscontrolPermissionsUpsertBatch500,
  PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest,
  PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse,
} from "../../types/accessControlPermissionsController/PostApiV1AccesscontrolPermissionsUpsertBatch.ts";
import { batchUpsertPermissionViewModelSchema } from "../batchUpsertPermissionViewModelSchema.ts";

/**
 * @description (Accepted) Requisição aceita.
 */
export const postApiV1AccesscontrolPermissionsUpsertBatch202Schema =
  z.any() as unknown as ToZod<PostApiV1AccesscontrolPermissionsUpsertBatch202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1AccesscontrolPermissionsUpsertBatch400Schema =
  z.any() as unknown as ToZod<PostApiV1AccesscontrolPermissionsUpsertBatch400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1AccesscontrolPermissionsUpsertBatch401Schema =
  z.any() as unknown as ToZod<PostApiV1AccesscontrolPermissionsUpsertBatch401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1AccesscontrolPermissionsUpsertBatch500Schema =
  z.any() as unknown as ToZod<PostApiV1AccesscontrolPermissionsUpsertBatch500>;

export const postApiV1AccesscontrolPermissionsUpsertBatchMutationRequestSchema =
  z.lazy(
    () => batchUpsertPermissionViewModelSchema,
  ) as unknown as ToZod<PostApiV1AccesscontrolPermissionsUpsertBatchMutationRequest>;

export const postApiV1AccesscontrolPermissionsUpsertBatchMutationResponseSchema =
  z.lazy(
    () => postApiV1AccesscontrolPermissionsUpsertBatch202Schema,
  ) as unknown as ToZod<PostApiV1AccesscontrolPermissionsUpsertBatchMutationResponse>;
